import { create } from 'zustand';

// Slot generico para que una pagina inyecte una accion (ej. "Imprimir PDF") en la barra de
// ruta compartida (Content.tsx), sin acoplar ese layout a paginas puntuales. Cada pagina que
// lo use debe limpiarlo al desmontar, para no dejar la accion de una pagina vieja pisando la
// siguiente.
export const usePageHeaderActionsStore = create((set) => ({
	headerAction: null,
	setHeaderAction: (node) => set({ headerAction: node }),
	clearHeaderAction: () => set({ headerAction: null }),
}));
